import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/app/(static)/learn/[language]/[nativeLanguage]/BreadcrumbsElement.tsx");
